import {HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {concatMap} from 'rxjs/operators';
import {SessionService} from './session.service';
import {environment} from "../../environments/environment";


class OrdsHttpHandler implements HttpHandler {

  // TODO - behind NGINX
  private readonly ordsUrl = environment.ordsUrl;

  constructor(private backend: HttpBackend, private sess: SessionService) {
  }

  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    return this.sess.obtainJWT()
      .pipe(
        concatMap(val => {
          const headers = new HttpHeaders().set('Authorization', `Bearer ${val.access_token}`).set('X-ID-TOKEN', `${val.id_token}`);
          return this.backend.handle(req.clone({url: `${this.ordsUrl}${req.url}`, headers}));
        })
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class OrdsHttpClient extends HttpClient {
  constructor(private backend: HttpBackend, private sess: SessionService) {
    super(new OrdsHttpHandler(backend, sess));
  }
}
